module.exports = __webpack_public_path__ + "static_pc/img/9.84b45b97.png";